const pageParamMiddleware = ({ search, next }) => {
    // Remove page param if any param has changed
    const newParams = next(search);
    if (!search.page) return newParams;
    if (search.page !== newParams.page) return newParams;
    return {
        ...newParams,
        page: undefined,
    };
};

export { pageParamMiddleware };
